var _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#11A0C4"
    },
    points: "302.933,503.467 183.467,503.467 166.4,349.867 320,349.867  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11A0C4"
    },
    d: "M280.798,494.199l-6.929-15.599l72.926-32.375c4.446-1.86,7.339-6.204,7.339-11.025v-39.253     c0-1.886-1.527-3.413-3.413-3.413l0,0h-39.253v-17.067h39.253c11.307,0,20.48,9.173,20.48,20.48l0,0V435.2     c0,11.605-6.921,22.093-17.587,26.667L280.798,494.199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.8,
    y: 341.333,
    style: {
      fill: "#87CED9"
    },
    width: 204.8,
    height: 17.067
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.467,
    y: 110.933,
    style: {
      fill: "#87CED9"
    },
    width: 119.467,
    height: 238.933
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.6,
    y: 42.667,
    style: {
      fill: "#11A0C4"
    },
    width: 51.2,
    height: 221.867
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DE4C3C"
    },
    d: "M302.933,298.667H183.467c0-18.85,15.283-34.133,34.133-34.133h51.2   C287.65,264.533,302.933,279.817,302.933,298.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#11A0C4"
    },
    d: "M200.533,8.533h85.333c9.429,0,17.067,7.637,17.067,17.067v17.067l0,0H183.467l0,0V25.6   C183.467,16.171,191.104,8.533,200.533,8.533z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#75462E"
    },
    d: "M243.2,384l-12.433,20.719c-4.113,6.878-1.869,15.787,5.009,19.891     c2.244,1.34,4.813,2.057,7.424,2.057l0,0c8.013-0.009,14.498-6.511,14.49-14.524c0-2.611-0.717-5.18-2.057-7.424L243.2,384z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#75462E"
    },
    points: "183.467,503.467 302.933,503.467 307.678,460.8 178.722,460.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.467,
    y: 298.667,
    style: {
      fill: "#75462E"
    },
    width: 119.467,
    height: 42.667
  })), /*#__PURE__*/React.createElement("rect", {
    x: 217.6,
    y: 110.933,
    style: {
      fill: "#126099"
    },
    width: 51.2,
    height: 153.6
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M183.467,102.4c-4.71,0-8.533,3.823-8.533,8.533v230.4H140.8V358.4h17.963l16.213,146.005   c0.478,4.326,4.139,7.603,8.491,7.595h119.467c4.352,0,8.004-3.268,8.482-7.595l2.85-25.668l39.347-16.87   c10.667-4.574,17.587-15.061,17.587-26.667v-39.253c0-11.307-9.173-20.48-20.48-20.48l0,0h-24.977l1.894-17.067H345.6v-17.067   h-34.133v-230.4c0-4.71-3.823-8.533-8.533-8.533h-25.6V51.2h25.6c4.71,0,8.533-3.823,8.533-8.533V25.6c0-14.14-11.46-25.6-25.6-25.6   h-85.333c-14.14,0-25.6,11.46-25.6,25.6v17.067c0,4.71,3.823,8.533,8.533,8.533h25.6v51.2H183.467z M209.067,119.467v137.387   c-6.212,1.314-12.041,4.011-17.067,7.893v-145.28H209.067z M217.6,273.067h51.2c10.846,0.017,20.514,6.844,24.141,17.067h-99.482   C197.086,279.91,206.754,273.084,217.6,273.067z M260.267,256h-34.133V119.467h34.133V256z M191.147,494.933l-2.842-25.6h109.833   l-2.884,25.6H191.147z M350.72,392.533c1.886,0,3.413,1.527,3.413,3.413l0,0V435.2c0,4.779-2.85,9.105-7.245,10.982l-30.455,13.056   l7.407-66.705H350.72z M300.041,452.267H186.359L175.932,358.4h134.537L300.041,452.267z M192,341.333V307.2h102.4v34.133H192z    M294.4,119.467v145.289c-5.026-3.883-10.854-6.579-17.067-7.893V119.467H294.4z M192,25.6c0-4.71,3.823-8.533,8.533-8.533h85.333   c4.71,0,8.533,3.823,8.533,8.533v8.533H192V25.6z M226.133,51.2h34.133v51.2h-34.133V51.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250.513,379.605c-2.773-4.036-8.303-5.06-12.339-2.287c-0.896,0.614-1.673,1.391-2.287,2.287l-12.433,20.719   c-6.554,10.906-3.029,25.062,7.876,31.616c10.906,6.554,25.062,3.029,31.616-7.876c4.395-7.305,4.395-16.435,0-23.74   L250.513,379.605z M248.388,415.113c-1.417,2.978-4.975,4.25-7.962,2.833c-2.978-1.417-4.25-4.975-2.833-7.962   c0.137-0.299,0.307-0.58,0.495-0.845l5.12-8.533l5.12,8.533C249.438,410.974,249.455,413.261,248.388,415.113z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8214f2d0d750701cef8397d3814e8409.svg";
export { ForwardRef as ReactComponent };